var map = {
	"./apple-store-badge-ca-ES.png": "soru",
	"./apple-store-badge-en-GB.png": "UunD",
	"./apple-store-badge-es-AR.png": "cBfw",
	"./apple-store-badge-es-CL.png": "Fz9h",
	"./apple-store-badge-es-CO.png": "wgGB",
	"./apple-store-badge-es-ES.png": "OCfN",
	"./apple-store-badge-es-MX.png": "n/Cj",
	"./apple-store-badge-es-UY.png": "N2//",
	"./apple-store-badge-pt-BR.png": "to8B"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GxlK";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/apple\-store\-badge\-.*\.png$
// module id = GxlK
// module chunks = 1